import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { isImpersonating } from 'legacy-src/components/impersonating/utils';
import isString from 'lodash/isString';

const SecondLevelNavList = (props) => {
  const { firstLevelActive, items, tag, itemTag } = props;

  const NavTag = tag;
  const ItemTag = itemTag;

  const {
    children: secondLevelItems = [],
    extraChildren: ExtraChildren = null,
  } = items.find((item) => item.id === firstLevelActive) || {};

  const heightOfLeftNavAPClassroomBanner = ' - 64px';
  const heightOfImpersonationBanner = isImpersonating() ? ' - 52px' : '';

  return (
    <nav className="mobile:grow" aria-label="Second level">
      <a
        className="text-base text-black absolute w-px h-px -left-96 top-auto
        focus:h-auto focus:w-auto focus:m-auto focus:static focus:inline-block"
        href="#main-content"
      >
        Skip Navigation
      </a>
      <NavTag
        id={`items-container-${firstLevelActive}`}
        style={{
          height: `calc(100%${heightOfLeftNavAPClassroomBanner}${heightOfImpersonationBanner})`,
          scrollbarWidth: 'thin',
        }}
        className="overflow-y-auto overflow-x-hidden bg-blue-100 list-none p-0 m-0 block w-64.6 mobile:w-full"
      >
        {secondLevelItems.map((item) => {
          const { id, isVisible, label } = item;

          if (
            (typeof isVisible === 'function' && isVisible() === false) ||
            !isString(label)
          ) {
            return null;
          }

          return <ItemTag key={id} item={item} />;
        })}
        {ExtraChildren && (
          <li>
            <ExtraChildren isParentExpanded />
          </li>
        )}
      </NavTag>
    </nav>
  );
};

SecondLevelNavList.propTypes = {
  items: PropTypes.array.isRequired,
  firstLevelActive: PropTypes.string.isRequired,
  tag: PropTypes.string,
  itemTag: PropTypes.func.isRequired,
};

SecondLevelNavList.defaultProps = {
  tag: 'ul',
};

export default withRouter(SecondLevelNavList);
